import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import AppLayout from "@/components/AppLayout";
import { CalculatorsDialog } from "@/components/CalculatorsDialog";
import { Calculator, Calendar, Wallet, ChevronRight, ScanSearch } from "lucide-react";

const TOOLS = [
  { id: "dpr", icon: Calendar, title: "Calcolo DPR", desc: "Calcola le date chiave (DPR, delibera, istruttoria, firma, scadenza CRM) a partire dall'inizio CQS e dalla durata.", testid: "tool-dpr" },
  { id: "loan", icon: Calculator, title: "Calcolatore Prestito", desc: "Disponibilità, rapporto rata/disp., margine di sicurezza, rata sostenibile e capitale stimato.", testid: "tool-loan" },
  { id: "residual", icon: Wallet, title: "Debito Residuo", desc: "Capitale iniziale, rate pagate, capitale rimborsato, interessi pagati e debito residuo a una data.", testid: "tool-residual" },
  { id: "dpr-recovery", icon: ScanSearch, title: "Recupero DPR da note", desc: "Trova clienti con DPR vuota ma dati CQS nel testo (es. \"CQS 330 X 120 DEC 06/2020\") e calcola la DPR teorica con il calcolatore esistente. Anteprima e salvataggio manuale.", testid: "tool-dpr-recovery", href: "/strumenti/recupero-dpr" },
];

export default function ToolsPage() {
  const [open, setOpen] = useState(null);
  const navigate = useNavigate();
  return (
    <AppLayout title="Calcolatori Finanziari" subtitle="Strumenti operativi">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {TOOLS.map((t) => (
          <button
            key={t.id}
            onClick={() => (t.href ? navigate(t.href) : setOpen(t.id))}
            data-testid={t.testid}
            className="text-left bg-white border border-slate-200 hover:border-[#B7955B] hover:shadow-md rounded-[3px] p-6 transition-all group"
          >
            <div className="w-11 h-11 bg-[#F5EFE3] text-[#8a6e3d] rounded-[3px] flex items-center justify-center mb-4 group-hover:bg-[#B7955B] group-hover:text-white transition">
              <t.icon className="w-5 h-5" strokeWidth={1.6} />
            </div>
            <h3 className="font-serif text-xl text-slate-900 mb-2">{t.title}</h3>
            <p className="text-sm text-slate-600 leading-relaxed">{t.desc}</p>
            <div className="mt-4 text-xs text-[#8a6e3d] font-medium uppercase tracking-wider flex items-center gap-1 group-hover:gap-2 transition-all">
              Apri <ChevronRight className="w-3 h-3" />
            </div>
          </button>
        ))}
      </div>
      <CalculatorsDialog open={!!open} type={open} onClose={() => setOpen(null)} />
    </AppLayout>
  );
}
